import { STAR_MAP, formatCompactNumber, getInitials } from 'utils/formatters';

import * as styled from '../styles/team-grid';

type Props = {
  members: Kudable.TeamMember[];
  accentColor: string;
};

export const TeamGrid = ({ members, accentColor }: Props) => {
  if (members.length === 0) return null;

  return (
    <div>
      <styled.Title>Our Team</styled.Title>
      <styled.Grid>
        {members.map((member) => {
          const fullName =
            `${member.first_name || ''} ${member.last_name || ''}`.trim() ||
            'Member';
          const card = (
            <styled.Card>
              <styled.Avatar $accent={accentColor}>
                {getInitials(member.first_name || '', member.last_name || '')}
              </styled.Avatar>
              <styled.Name>{fullName}</styled.Name>
              {member.role && <styled.Role>{member.role}</styled.Role>}
              <styled.Stars>
                {member.average_rating
                  ? STAR_MAP[Math.round(member.average_rating)] || '★★★★★'
                  : 'No reviews'}
              </styled.Stars>
              <styled.Count>
                {formatCompactNumber(member.review_count)} reviews
              </styled.Count>
            </styled.Card>
          );

          return member.profile_token ? (
            <styled.Link key={member.id} href={`/p/${member.profile_token}`}>
              {card}
            </styled.Link>
          ) : (
            <span key={member.id}>{card}</span>
          );
        })}
      </styled.Grid>
    </div>
  );
};
